// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const Feed = require('client-v2/common/containers/feed/component-dumb')
const { createFeedSmartComponent } = require('client-v2/common/containers/feed/component-smart')
const createEmptyMessage = require('client-v2/common/containers/feed/empty-message')
// Sibling imports
const feedActions = require('./actions')
const feedSelectors = require('./selectors')

const commonSmartFeed = createFeedSmartComponent(feedActions, feedSelectors)

function mapStateToProps(state) {
  const commonStateProps = commonSmartFeed.mapStateToProps(state)
  let emptyMessage
  if (!commonStateProps.items.size) {
    emptyMessage = emptyMessageState(state)
  }
  return Object.assign(commonStateProps, {
    emptyMessage
  })
}

module.exports = connect(
  mapStateToProps,
  commonSmartFeed.mapDispatchToProps
)(
  ImmutableToJS(
    Feed
  )
)

// Empty message helpers

function emptyMessageState(state) {
  if (state.router.action === 'search.showDomainPosts') {
    return EmptyDomainPostsMessage
  }
  return EmptyQueryMessage
}

const EmptyDomainPostsMessage = createEmptyMessage(() => {
  return `Sorry, we could not find any content.`
})

const EmptyQueryMessage = createEmptyMessage(() => {
  return [
    'Sorry, we could not find any content.',
    'Consider broadening your search terms.'
  ].join('\n\n')
})
